import { FC } from 'react';

import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { ArrowIcon, ProfileCreatedModalIcon } from 'assets';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { Button } from 'view/components';
import * as S from 'view/modals/OnboardingWizard/styled';

interface SuccessStepProps {
  onClose: () => void;
}

const SuccessStep: FC<SuccessStepProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const { role, jobSeekerProfile } = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  const handleGoToHome = () => {
    onClose();
    if (role?.name === RolesEnum.JOB_SEEKER) {
      navigate('/profile/job-list');
    } else {
      navigate('/candidates/candidates-list');
    }
  };

  const handleViewProfile = () => {
    onClose();
    if (role?.name === RolesEnum.JOB_SEEKER) {
      navigate(`/candidates/candidate-profile?id=${jobSeekerProfile?.id}`);
    } else {
      navigate('/profile/profile-settings');
    }
  };

  return (
    <S.WizardContent>
      <S.StepImage>
        <ProfileCreatedModalIcon />
      </S.StepImage>
      <S.StepHeader>
        <S.StepTitle>Profile successfully created!</S.StepTitle>
        <S.StepSubtitle>
          Your profile is set! Start exploring job opportunities tailored to your skills.
        </S.StepSubtitle>
      </S.StepHeader>

      <S.WizardFooter>
        <Button variant="outlined" text="Go to home" onClick={handleGoToHome} />
        <Button
          variant="contained"
          text="View profile"
          onClick={handleViewProfile}
          endIcon={<ArrowIcon rotate="right" color="#FFFFFF" />}
        />
      </S.WizardFooter>
    </S.WizardContent>
  );
};

export default SuccessStep;
